<template>
  <div class="invoiceContent" v-if="isLogined">
    <div class="deliverySaveBtn"> <input type="button" value="添加" @click="add"></div>
    <div class="deliveryInvoiceList"> 
      <table>
        <tr class="invoiceHead">
          <th class="headName">发票抬头</th>
          <th class="invoiceHeadType">发票类型</th>
          <th class="invoiceHeadType1">抬头类型</th>
          <th class="dutyParagraph">税号</th>      
          <th>操作</th>
        </tr>
        <tr v-for="(item,i) in addList" :key="i">
          <td>{{item.invoiceHeader}}</td>
          <td><el-tag type="success"> {{item.invoiceTypeDisplay}}</el-tag>     </td>
          <td><el-tag type="warning" style="margin-top:5px;"> {{item.invoiceHeaderTypeDisplay}}</el-tag></td>
          <td>{{item.dutyParagraph}}</td>      
          <td>            
            <div><span class="edit" @click="edit(item)">修改</span>|<span class="del" @click="del(item.id)">删除</span></div>
          </td>
        </tr>
      </table>   
    </div>   
    <editInvoice ref="editInvoice" @fetch-data="_invoiceList"></editInvoice>
  </div>
  <div class="invoiceContent1" v-else >
    <div @click="toLogin()">亲,请先登陆</div>
  </div>
</template>
<style>
@import '../../styles/invoice.css';
</style>
<script>
  import api from '@/api'
  import { getInvoiceList, createOrEdit, Delete } from '@/api/invoice'
  import EditInvoice from './components/EditInvoice'
  import { mapState} from 'vuex'
  export default {
    components: {     EditInvoice },
    data () {    
      return {
        addList: [],    
        msg: {
          id: '',
          area:'',
          city:'',
          province:'',
          name: '',
          mobile: '',
          invoice: '',
          isDefault: false
        },
      }
    },
    computed: {
      ...mapState(['isLogined']), 
    },
    methods: { 
      toLogin() {
        this.$router.push({ name: 'userLogin' })
      },
      message (m) {
        this.$message.error({
          message: m
        })
      },
      async _invoiceList () {
        await getInvoiceList().then(res => {
          if (res.data.success === true) {
            this.addList = res.data.result
          } else {
           this.addList = []
          }
        }).catch(error => {
            this.addList = []
        })
      },
      async _invoiceAddOrUpdate (params) {
       await createOrEdit(params).then(res => {
          if (res.data.success === true) {
            this.$message({ message: '操作成功',type: 'success',customClass: 'c-msg'})
            this._invoiceList()
            this.update();
          } else {
            this.message(res.message)
          }
        })
      },
      // 保存
      add () {
        this.$refs['editInvoice'].show()
      },
      edit (row) {
        this.$refs['editInvoice'].show({id:row.id})
      },
      // 删除
       del (id) {
        this.$confirm('确定删除吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
        }).then((res) => {
           Delete({id:id}).then(res => {
            this.$message({
                message: '删除成功',
                type: 'success',
                customClass: 'c-msg'
              })
           this._invoiceList()
          })
        })   
      },
     
    },
    created () {
     if(this.isLogined) 
     {     
        this._invoiceList()
     }
    },
    mounted() {
     
    }
  }
</script>


// WEBPACK FOOTER //
// invoiceList.vue?21693c29